export default "__VITE_ASSET__BKI$PmMC__"